'use strict';

import modelViewTemplate from './modelView.html';
import '@google/model-viewer';

var modelViewController = function($window, $controller, $state, $location, $css, modelViewService, loggingService) {
    var vm = this;
    vm.modelViewSettings = null;

    var initialPhi = null;
    var initialTheta = null;
    var initialRadius = null;
    var zoomedIn = 0;
    var viewedBack = 0;
    const PI = 3.1415;
    var start = null;
    var assetSpecified=false;

    vm.model = document.querySelector('#model');
    vm.slideButton = document.querySelector('#slide-button');

    vm.$onInit = function() {
        vm.initializeModelViewer();
        vm.initializeNextClick();
    }

    vm.initializeModelViewer = function() {

        // First, validate and get the model URL.

        $window.document.title = "3D Viewer Powered by ShopperMX";

        modelViewService.getModelViewLaunchSettings(vm.studyId, vm.assetId, $location.search()).then((returnedSettings) => {
            
            if(!returnedSettings)
            {
                console.log("Error downloading model viewer settings.")
                loggingService.warn('modelView.component: error downloading model viewer settings.');
            }

            vm.modelViewSettings = returnedSettings;
            vm.model.src = returnedSettings.assetUrl;
            vm.model.environmentImage = 'modelView/grey.png';

            var recordId = $location.search().record;
            if(recordId)
            {
                vm.generateWatermark(recordId);
            }
        });

        vm.generateWatermark = function(watermarkText) {

            var watermark = document.querySelector('#watermark');
            // Numbers only.
            if(!isNaN(watermarkText))
            {
                watermark.textContent += watermarkText + ' ';
            }
        };

        vm.model.addEventListener('error', (ev) => {
            ev.preventDefault();
        
            if (ev.detail.message.indexOf('Could not set model source') !== -1) {
                vm.displayError();
            }
            else {
                vm.displayError();
            }

            loggingService.warn('modelView.component: model.error: {errorMessage}', { "errorMessage": ev.detail.message });

        });

        vm.displayError = function() {
            model.poster = 'modelView/errorcube-warning.png';
            model.style.height = '50%';
            model.style.width = '50%';
            vm.slideButton.style.display='none';
        };
    
        vm.model.addEventListener('load', (ev) => {
            ev.preventDefault();
            start = new Date();
            vm.slideButton.style.display='flex';
            console.log("load event, starting viewing timer " + start);
            loggingService.info('modelView.component: model.load: starting viewing timer.', { "startTime": start });
        });
    
        vm.model.addEventListener('camera-change', (ev) => {
            ev.preventDefault();
            if (ev.detail.source =='user-interaction'){
                var orbit = model.getCameraOrbit();
                if (initialRadius == null){
                    initialPhi = orbit.phi;
                    initialTheta = orbit.theta;
                    initialRadius = orbit.radius;
                }
                else {
                    if (orbit.radius < (.9 * initialRadius)) {
                        zoomedIn = 1;
                    }
                    if (Math.abs(orbit.theta) > PI) {
                        viewedBack = 1;
                    }
    
                }
            }
        });
        
    };
    
    vm.initializeNextClick = function() {

        document.querySelector(".slides").addEventListener('beforexrselect', (ev) => {
            ev.preventDefault();
        });

        vm.slideButton.addEventListener('click', element => {
            vm.completeViewing();
        });
    };

    vm.completeViewing = function() {
        var end = new Date();
        var ms = end - start;

        var zoomData = { 'zoomedIn': zoomedIn, 'viewedBack': viewedBack, 'secondsViewed': Math.round(ms / 1000) };
        
        loggingService.info('modelView.component: completeViewing {zoomData}', zoomData);

        // Append these new data values to the location for ease of
        // updating the ticket.
        for (var zoomDataKey in zoomData) {
            $location.search(zoomDataKey, zoomData[zoomDataKey]);
        }

        var fullRedirectUrl = vm.modelViewSettings.redirectUrl;

		var originalQueryStringParams = $location.search();
        var originalQueryString = Object.keys(originalQueryStringParams)
            .map(key => `${key}=${originalQueryStringParams[key]}`)
            .join('&');
        
        fullRedirectUrl = fullRedirectUrl + '?' + originalQueryString;

        modelViewService.addTicketParameters(vm.modelViewSettings.ticketId, $location.search()).then((result) => {
            
            if(!result)
            {
                console.log("Error saving values.")
                loggingService.warn('modelView.component: addTicketParameters: error saving ticket parameters');
            }

            loggingService.info('modelView.component: completeViewing: redirecting', { "redirectUrl": fullRedirectUrl });
            loggingService.flush();

            $window.location.href = fullRedirectUrl;

        });

    };
};

modelViewController.$inject = [ '$window', '$controller', '$state', '$location', '$css', 'modelViewService', 'loggingService' ];

export var modelViewComponent = {
    name: 'modelView',
    template: modelViewTemplate,
    controller: modelViewController,
    controllerAs: 'vm',
    bindings: {
        studyId: '@',
        assetId: '@'
    },
    css: 'modelView/modelView.css'
};

export var modelViewRoute = {
    name: 'modelView',
    url: '/modelView/{studyId}/{assetId}',
    component: 'modelView',
    resolve: {
        studyId: ['$transition$', function ($transition$) {
            return $transition$.params().studyId;
        }],
        assetId: ['$transition$', function ($transition$) {
            return $transition$.params().assetId;
        }]
    }
};